(function () {
	const scrollTop = () => {
		const btnScrollTop = document.querySelector(".scroll-top");
		window.addEventListener("scroll", function () {
			if (btnScrollTop) {
				if (scrollY > document.documentElement.clientHeight) {
					btnScrollTop.classList.add("show");
				} else {
					btnScrollTop.classList.remove("show");
				}
			}
		});

		btnScrollTop.onclick = () => {
			const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
			window.scrollTo({ top: 0, behavior: prefersReducedMotion ? "auto" : "smooth" });
		};
	};

	scrollTop();

	document.addEventListener("shopify:section:load", function () {
		scrollTop();
	});
})();
